/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Agent_Tooling_ArtifactsInputs */

const en_directory_agent_readiness_check_agent_tooling_artifacts = /** @type {(inputs: Directory_Agent_Readiness_Check_Agent_Tooling_ArtifactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent tooling artifacts`)
};

const zh_directory_agent_readiness_check_agent_tooling_artifacts = /** @type {(inputs: Directory_Agent_Readiness_Check_Agent_Tooling_ArtifactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`智能体工具产物`)
};

/**
* | output |
* | --- |
* | "Agent tooling artifacts" |
*
* @param {Directory_Agent_Readiness_Check_Agent_Tooling_ArtifactsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_agent_tooling_artifacts = /** @type {((inputs?: Directory_Agent_Readiness_Check_Agent_Tooling_ArtifactsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Agent_Tooling_ArtifactsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_agent_tooling_artifacts(inputs)
	return zh_directory_agent_readiness_check_agent_tooling_artifacts(inputs)
});
export { directory_agent_readiness_check_agent_tooling_artifacts as "directory.agent_readiness.check.agent_tooling_artifacts" }